export default __webpack_public_path__ + "src/appV2/redesign/system/ui-components/illustrations/assets/parachute-gift.png";